/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KoreaExpressOutboundInfoOrderInfoVo } from './KoreaExpressOutboundInfoOrderInfoVo';
import {
    KoreaExpressOutboundInfoOrderInfoVoFromJSON,
    KoreaExpressOutboundInfoOrderInfoVoFromJSONTyped,
    KoreaExpressOutboundInfoOrderInfoVoToJSON,
    KoreaExpressOutboundInfoOrderInfoVoToJSONTyped,
} from './KoreaExpressOutboundInfoOrderInfoVo';

/**
 * 
 * @export
 * @interface KoreaExpressOutboundInfoVo
 */
export interface KoreaExpressOutboundInfoVo {
    /**
     * 出库待定总数
     * @type {number}
     * @memberof KoreaExpressOutboundInfoVo
     */
    waitOutboundCount?: number;
    /**
     * 快递出库总数
     * @type {number}
     * @memberof KoreaExpressOutboundInfoVo
     */
    expressOutboundCount?: number;
    /**
     * 一件代发总数
     * @type {number}
     * @memberof KoreaExpressOutboundInfoVo
     */
    stockOutboundCount?: number;
    /**
     * 总箱数
     * @type {number}
     * @memberof KoreaExpressOutboundInfoVo
     */
    totalBoxCount?: number;
    /**
     * 总重量
     * @type {number}
     * @memberof KoreaExpressOutboundInfoVo
     */
    totalWeight?: number;
    /**
     * 订单列表
     * @type {Array<KoreaExpressOutboundInfoOrderInfoVo>}
     * @memberof KoreaExpressOutboundInfoVo
     */
    koreaExpressOutboundInfoOrderInfoVOS?: Array<KoreaExpressOutboundInfoOrderInfoVo>;
}

/**
 * Check if a given object implements the KoreaExpressOutboundInfoVo interface.
 */
export function instanceOfKoreaExpressOutboundInfoVo(value: object): value is KoreaExpressOutboundInfoVo {
    return true;
}

export function KoreaExpressOutboundInfoVoFromJSON(json: any): KoreaExpressOutboundInfoVo {
    return KoreaExpressOutboundInfoVoFromJSONTyped(json, false);
}

export function KoreaExpressOutboundInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KoreaExpressOutboundInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'waitOutboundCount': json['waitOutboundCount'] == null ? undefined : json['waitOutboundCount'],
        'expressOutboundCount': json['expressOutboundCount'] == null ? undefined : json['expressOutboundCount'],
        'stockOutboundCount': json['stockOutboundCount'] == null ? undefined : json['stockOutboundCount'],
        'totalBoxCount': json['totalBoxCount'] == null ? undefined : json['totalBoxCount'],
        'totalWeight': json['totalWeight'] == null ? undefined : json['totalWeight'],
        'koreaExpressOutboundInfoOrderInfoVOS': json['koreaExpressOutboundInfoOrderInfoVOS'] == null ? undefined : ((json['koreaExpressOutboundInfoOrderInfoVOS'] as Array<any>).map(KoreaExpressOutboundInfoOrderInfoVoFromJSON)),
    };
}

export function KoreaExpressOutboundInfoVoToJSON(json: any): KoreaExpressOutboundInfoVo {
    return KoreaExpressOutboundInfoVoToJSONTyped(json, false);
}

export function KoreaExpressOutboundInfoVoToJSONTyped(value?: KoreaExpressOutboundInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'waitOutboundCount': value['waitOutboundCount'],
        'expressOutboundCount': value['expressOutboundCount'],
        'stockOutboundCount': value['stockOutboundCount'],
        'totalBoxCount': value['totalBoxCount'],
        'totalWeight': value['totalWeight'],
        'koreaExpressOutboundInfoOrderInfoVOS': value['koreaExpressOutboundInfoOrderInfoVOS'] == null ? undefined : ((value['koreaExpressOutboundInfoOrderInfoVOS'] as Array<any>).map(KoreaExpressOutboundInfoOrderInfoVoToJSON)),
    };
}

